import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ accept, ...args }) {
    super(args)
    const child = this.getComponentWithVModel('attachment-input')
    child.attrs = {
      ...child.attrs,
      accept
    }
    this.children = [child]
  }
}
